import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { IconTrash } from '../../../../assets/icon';
import Text from '../../../../components/Text/Text';
import Input from '../../../../components/Input/Input';
import CustomSelect from '../../../../components/Select/CustomSelect';
import setCreatePartTypeModalState from '../../../../actions/createPartTypeModal/createPartTypeModal';
import getWarehouseMpnInfo from '../../../../thunks/coilovers/warehouse/getWarehouseMpnInfo';
import { orderedPartsIncludeList } from '../../../../constants/orderedPartsInclude';

const orderedItemClassName = 'relative border border-dashed border-[#EFF2F5] rounded-[6px] p-[15px] mb-[20px]';
const iconContainerClassName = 'absolute top-[5px] right-[15px] w-[20px] h-[20px] z-[1] flex items-center';
const iconClassName = 'text-danger hover:text-danger-hover';
const labelContainerClassName = 'mb-[6px]';
const labelTextClassName = 'text-[13px]';
const inputClassName = 'py-[11px] px-[13px] font-normal text-[13px]';
const dividerClassName = 'mr-[20px]';

const OrderedPartsNewItem = ({
  showDelete,
  onDelete,
  item,
  onChangeItem,
  getOrderedPartsListLoading,
  getOrderedPartsList,
  brandList,
  brandListLoading
}) => {
  const [timer, setTimer] = useState(null);
  const dispatch = useDispatch();
  const {
    warehouseMpnInfo: {
      loading: infoLoading,
      data: infoData
    },
  } = useSelector((state) => ({
    warehouseMpnInfo: state?.getWarehouseMpnInfo
  }));

  const {
    ordered_part_type: type,
    ordered_part_included: included,
    ordered_part_brand: brand,
    ordered_part_mpn: mpn,
    ordered_part_qty_in_order: qtyInOrder,
    cost,
    costFor,
    id
  } = item;

  const onChangeMpn = (value) => {
    clearTimeout(timer);
    const timeout = setTimeout(() => dispatch(getWarehouseMpnInfo(value.trim())), 800);
    setTimer(timeout);
    onChangeItem(id, { ordered_part_mpn: value.trim() });
  };

  useEffect(() => {
    if (infoData[mpn]) {
      onChangeItem(id, {
        ordered_part_type: {
          label: infoData[mpn]?.part_whs_type,
          value: infoData[mpn]?.part_whs_type,
        },
        ordered_part_brand: {
          label: infoData[mpn]?.part_whs_brand,
          value: infoData[mpn]?.part_whs_brand,
        },
        ordered_part_included: {
          label: infoData[mpn]?.part_whs_included_type,
          value: infoData[mpn]?.part_whs_included_type,
        },

      });
    }
  }, [infoData]);

  return (
    <div className={orderedItemClassName}>
      {showDelete && (
        <div
          className={iconContainerClassName}
          role="presentation"
          onClick={() => onDelete(id)}
        >
          <IconTrash className={iconClassName} />
        </div>
      )}
      <div className="flex flex-row justify-between">
        <div className="flex-1">
          <Text text="Mpn:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <Input
            containerStyle="d-col"
            inputStyle={inputClassName}
            type="text"
            name="mpn"
            value={mpn}
            placeholder="Mpn"
            onChange={({ target: { value } }) => onChangeMpn(value)}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text text="Part type:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomSelect
            value={[type]}
            placeholder={`${getOrderedPartsListLoading ? 'Loading...' : 'Select type'}`}
            isDisabled={getOrderedPartsListLoading || infoLoading}
            options={getOrderedPartsList}
            onChange={(data) => onChangeItem(id, { ordered_part_type: data })}
            infoText="Create type"
            onInfoClick={() => dispatch(setCreatePartTypeModalState({ visible: true }))}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text text="Included:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomSelect
            value={[included]}
            placeholder="Included"
            options={orderedPartsIncludeList}
            onChange={(data) => onChangeItem(id, { ordered_part_included: data })}
          />
        </div>
      </div>
      <br />
      <div className="flex flex-row justify-between">
        <div className="flex-1">
          <Text text="Brand:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomSelect
            options={brandList}
            value={[brand]}
            placeholder={brandListLoading ? 'Loading...' : 'Select brand'}
            isDisabled={brandListLoading}
            isSearchable
            onChange={(data) => onChangeItem(id, { ordered_part_brand: data })}
          />
        </div>
      </div>
      <br />
      <div className="flex flex-row justify-between">
        <div className="flex-1">
          <Text text="Qty:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <Input
            containerStyle="d-col"
            inputStyle={inputClassName}
            type="number"
            step={1}
            min={1}
            name="qtyOnOrder"
            value={`${qtyInOrder}`}
            placeholder="Qty in order"
            onChange={({ target: { value } }) => onChangeItem(id, {
              ordered_part_qty_in_order: parseInt(value),
              costFor: parseInt(value) * cost
            })}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text text="Cost:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <Input
            containerStyle="d-col"
            inputStyle={inputClassName}
            type="number"
            step={0.01}
            min={0.01}
            name="qtyOnOrder"
            value={`${cost}`}
            placeholder="Cost"
            onChange={({ target: { value } }) => onChangeItem(id, {
              cost: value,
              costFor: parseFloat(value) * (qtyInOrder || 1)
            })}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text
            text={`Cost for ${qtyInOrder || 1}:`}
            styleContainer={labelContainerClassName}
            textStyle={labelTextClassName}
          />
          <Input
            containerStyle="d-col"
            inputStyle={inputClassName}
            type="number"
            step={0.01}
            min={0.01}
            name="qtyOnOrder"
            value={`${costFor}`}
            placeholder="Cost for"
            onChange={({ target: { value } }) => onChangeItem(id, {
              cost: parseFloat(value) / (qtyInOrder || 1),
              costFor: value
            })}
          />
        </div>
      </div>
    </div>
  );
};

OrderedPartsNewItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    ordered_part_mpn: PropTypes.string,
    ordered_part_type: PropTypes.shape({}),
    ordered_part_included: PropTypes.shape({}),
    ordered_part_brand: PropTypes.shape({}),
    ordered_part_qty_in_order: PropTypes.number,
    ordered_part_price_in_order: PropTypes.number,
    cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    costFor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  showDelete: PropTypes.bool,
  getOrderedPartsListLoading: PropTypes.bool,
  brandListLoading: PropTypes.bool,
  onChangeItem: PropTypes.func,
  onDelete: PropTypes.func,
  getOrderedPartsList: PropTypes.arrayOf(PropTypes.shape({})),
  brandList: PropTypes.arrayOf(PropTypes.shape({})),
};

OrderedPartsNewItem.defaultProps = {
  item: {},
  showDelete: false,
  getOrderedPartsListLoading: false,
  brandListLoading: false,
  onChangeItem: () => {},
  onDelete: () => {},
  getOrderedPartsList: [],
  brandList: [],

};

export default OrderedPartsNewItem;
